export default function(fields_data) {
  var self = this;
  self.$el = $('#js-course-enrollment-fields-form');

  self.fields = ko.observableArray([]);
  self.saving = ko.observable(false);
  self.requiredOptions = [
    {value: 'no', label: 'No'},
    {value: 'transcript', label: 'Required For Transcript'},
    {value: 'access', label: 'Required For Course Access'},
    {value: 'enrollment', label: 'Required To Enroll'},
    {value: 'always', label: 'Always Required'},
  ];

  self.bindData = function(fields_data) {
    var mapped = ko.mapping.fromJS(fields_data);
    self.fields(mapped());
    ko.utils.arrayForEach(self.fields(), function(_item) {
      _item.visible.subscribe(function(visible){
        self.updateField(_item.id(), {visible: visible});
      });
      _item.required.subscribe(function(required){
        self.updateField(_item.id(), {required: required});
      });
    });
  };

  self.updateField = function(id, attrs) {
    var url = Kadenze.Routes.enrollment_field_path({id: id});
    var method = 'PUT';
    var data = {enrollment_field: attrs};

    Kadenze.UIUtil.makeRequest(url, method, data, self.$el,
      function(xhr, settings) { //BeforeSave
        Kadenze.UIUtil.showLoadingIndicator(self.$el);
      },
      function(data, textStatus, xhr) { //Success
        var params = {
          title: 'Successfully updated ' + data.label + '.',
          type: 'success',
        };

        new Kadenze.Notice(params);
      },
      function(xhr, textStatus, errorThrown) { //Error
        Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
      },
      function(xhr, textStatus) { //Complete
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      });
  };

  self.delete = function(id){
    return function() {
      var url = Kadenze.Routes.enrollment_field_path({id: id});
      var method = 'DELETE';

      Kadenze.UIUtil.makeRequest(url, method, {}, self.$el,
        function(xhr, settings) { //BeforeSave
          Kadenze.UIUtil.showLoadingIndicator(self.$el);
        },
        function(data, textStatus, xhr) { //Success
          var params = {
            title: 'Successfully removed ' + data.label + '.',
            type: 'success',
          };

          new Kadenze.Notice(params);
          self.fields.remove(function(item) {
            return item.id === id;
          });
        },
        function(xhr, textStatus, errorThrown) { //Error
          Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
        },
        function(xhr, textStatus) { //Complete
          Kadenze.UIUtil.hideLoadingIndicator(self.$el);
        });

    };
  };

  self.initSortable = function(){
    self.$el.find('.display-table__body').sortable({
      items: '.display-table__data',
      handle: '.action-btn--move',
      helper: function(e, ui) {
        ui.children().each(function() {
          $(this).width($(this).width());
        });
        return ui;
      },
      update: function(e, ui) {
        var self = this;
        $.ajax({
          url: Kadenze.Routes.reorder_enrollment_fields_path(),
          type: 'POST',
          data: $(this).sortable('serialize'),
          beforeSend: function(xhr, settings) {
            Kadenze.UIUtil.showLoadingIndicator($(self));
          },
          success: function(data, textStatus, xhr) {
            var params = {
              title: 'Successfully reordered fields.',
              type: 'success',
            };
            new Kadenze.Notice(params);
          },
          error: function(xhr, textStatus, errorThrown) {
            var params = {
              title: 'We were unable to reorder these fields.',
              type: 'error',
            };
            new Kadenze.Notice(params);
          },
          complete: function(xhr, textStatus) {
            Kadenze.UIUtil.hideLoadingIndicator($(self));
          }
        });
      }
    });
  };

  const __construct = function(that) {
    that.bindData(fields_data);
    that.initSortable();
  }(this);
}

